import { FeaturesWithImage as FeaturesWithImageUI } from "@carfax/web-ui/components/FeaturesWithImage";
import { ModuleFeaturesWithImage } from "@carfax/contentful/PageModularModule";

interface FeaturesWithImageProps {
  module: ModuleFeaturesWithImage;
}

const renderIllustration = (asset?: { url: string; title?: string }) =>
  asset?.url ? <img src={asset.url} alt={asset.title || ""} /> : null;

export const FeaturesWithImage = (props: FeaturesWithImageProps) => {
  const { module } = props;
  const {
    badgeText,
    headline,
    headingLevel,
    features,
    buttonLabelExpanded,
    buttonLabelCollapsed,
    mobileIllustration,
    desktopIllustration,
    defaultExpanded,
  } = module;

  return (
    <FeaturesWithImageUI
      badgeText={badgeText}
      headline={headline}
      headingLevel={headingLevel}
      features={features.map((feature) => ({
        title: feature.title,
        description: feature.description,
        icon: feature.icon ? <img src={feature.icon.url} alt={feature.icon.title || ""} /> : undefined,
      }))}
      buttonLabelExpanded={buttonLabelExpanded}
      buttonLabelCollapsed={buttonLabelCollapsed}
      mobileIllustration={renderIllustration(mobileIllustration)}
      desktopIllustration={renderIllustration(desktopIllustration)}
      defaultExpanded={defaultExpanded}
    />
  );
};
